<template>
  <card-item
    :data="isPost ? postInfo : data"
    :show-date="showDate"
    :is-incard="isPost ? isInCard : false"
  >
    <slot></slot>
  </card-item>
</template>

<script>
import CardItem from './cardItem'
import {parsePost} from '@/utils/filter'
export default {
  components: {
    'card-item': CardItem
  },

  props: {
    data: {
      type: Object
    },
    isInCard: {
      type: Boolean
    },
    showDate: {
      type: Boolean
    }
  },

  computed: {
    isHost () {
      return this.data.TopicUserName === this.data.UserName
    },
    postId () {
      if (this.isHost) {
        return parsePost(this.data.CommentContent, this.isHost)
      }
      return false
    },
    isPost () {
      if (this.postId) {
        this.$store.dispatch('getPostInfo', {
          id: this.postId,
          data: this.data
        })
        return true
      }
      return false
    },
    postInfo () {
      var postInfo = Object.assign({}, this.data, this.$store.state.list.postInfo[this.postId])
      return postInfo
    },
    favoredCount () {
      const praiseInfo = this.$store.state.list.praiseCountList
      if (praiseInfo[this.data.CommentID]) {
        return praiseInfo[this.data.CommentID].count
      }
      return undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// card.vue?5b49333c